export default __webpack_public_path__ + "static/media/174.7955b04c.jpg";